import { tv } from "tailwind-variants"
import { type VariantProps } from "tailwind-variants"

export type LinkVariantProps = VariantProps<typeof linkVariants>

export const linkVariants = tv({
  base: "cursor-pointer no-underline",
  variants: {
    variant: {
      default: "text-link hover:text-link-hover",
      unstyled: "",
    },
  },
})
